import React from 'react';

// The frame the three account screens share (choose / log in / sign up): the start
// artwork behind a dark veil, the brand on top and one panel with the form.
export function AuthShell({ title, subtitle, children, onSubmit }) {
  const Panel = onSubmit ? 'form' : 'div';
  return (
    <div className="fp-root" style={styles.container}>
      <div style={styles.veil} />
      <h1 className="fp-brand fp-rise" style={styles.brand}>FootParadise</h1>
      <Panel className="fp-panel fp-rise" style={{ ...styles.panel, '--i': 1 }} onSubmit={onSubmit}>
        <div className="fp-halftone" />
        <div style={styles.inner}>
          {title && <h2 className="fp-title fp-title--white" style={styles.title}>{title}</h2>}
          {subtitle && <p style={styles.subtitle}>{subtitle}</p>}
          {children}
        </div>
      </Panel>
    </div>
  );
}

const styles = {
  container: {
    position: 'relative',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '18px',
    backgroundColor: '#1b0a33',
    backgroundImage: 'url(/start-background.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    padding: '24px 18px',
    paddingTop: 'max(24px, env(safe-area-inset-top))',
  },
  veil: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(180deg, rgba(27,10,51,0.55) 0%, rgba(27,10,51,0.78) 55%, rgba(20,6,31,0.92) 100%)',
  },
  brand: {
    position: 'relative',
    margin: 0,
    fontSize: '40px',
    lineHeight: 1,
    textAlign: 'center',
  },
  panel: {
    width: '100%',
    maxWidth: '360px',
  },
  inner: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '13px',
    padding: '22px 18px 20px',
  },
  title: {
    fontSize: '23px',
  },
  subtitle: {
    margin: '-4px 0 2px',
    fontSize: '13.5px',
    lineHeight: 1.4,
    color: '#eadcff',
    textAlign: 'center',
  },
};

export default AuthShell;
